<template>
  <!--[[预览]]-->
  <div class='preview-box'>
    <div class='preview-header'>
      <span class='tit' @click='cityChang'>{{ cityName }}</span>
      <img src='@/assets/img/preview-bot.png'/>
      <van-search disabled placeholder="搜索" />
    </div>
    <div v-for='(item,index) in floorList' :key='index'>
      <ul class='preview-banner' v-if='item.floorName === "banner2-content"'>
        <template v-for='(list,ind) in item.dataList'>
          <li v-if='ind<3' :key='ind'><img :src='list.imageUrl'></li>
        </template>
      </ul>
      <div class='preview-ten' v-if='item.floorName === "discovertype-gridtype"'>
        <div class='preview-ten-item' v-for='(list,ind) in item.dataList' :key='ind'>
          <img :src='list.imageUrl'>
          <span>{{ list.title }}</span>
        </div>
      </div>
      <div class='preview-tow' v-if='item.floorName === "left-two-content"'>
         <div class='preview-tow-item'>
           <img :src='item.dataList[0].imageUrl'>
           <dl>
             <dt>{{ item.dataList[0].title }}</dt>
             <dd>{{ item.dataList[0].subTitle1 }}</dd>
           </dl>
         </div>
        <template v-if='item.dataList[1]'>
          <div class='solid'></div>
          <div class='preview-tow-item'>
            <img :src='item.dataList[1].imageUrl'>
            <dl>
              <dt>{{ item.dataList[1].title }}</dt>
              <dd>{{ item.dataList[1].subTitle1 }}全部商户</dd>
            </dl>
          </div>
        </template>
       </div>
      <div
        class='preview-bg-box'
        v-if='item.floorName === "inner-three-content1"'
        :style="{'background-image': 'url('+item.floorImage+')','background-size': '100% 100%'}"
      >
        <template v-for='(list,ind) in item.dataList' >
          <div v-if='ind<3' class='preview-bg-box-item' :key='ind'>
            <img :src='list.imageUrl'>
            <dl>
              <dt>{{ list.title }}</dt>
              <dd>{{ list.subTitle1 }}</dd>
            </dl>
          </div>
        </template>
      </div>
     <div class='preview-two-three' v-if='item.floorName === "commom-two-three"'>
        <div class='preview-title'>
          <span>{{ item.floorTitle }}</span>
          <div class='preview-title-arrow' v-if='item.isMore === "0"'>
            <span>更多</span>
            <img src='@/assets/img/arrow-right.png'>
          </div>
        </div>
        <div class='gild'>
          <template v-for='(list,ind) in item.dataList'>
            <img :src='list.imageUrl' v-if='ind<5' :key='ind'>
          </template>
        </div>
      </div>
     <div class='preview-one-three' v-if='item.floorName === "one-three"'>
       <div class='preview-title'>
         <span>{{ item.floorTitle }}</span>
         <div class='preview-title-arrow' v-if='item.isMore === "0"'>
           <span>更多</span>
           <img src='@/assets/img/arrow-right.png'>
         </div>
       </div>
       <div class='gild'>
         <template v-for='(list,ind) in item.dataList'>
           <img :src='list.imageUrl' v-if='ind<4' :key='ind'>
         </template>
       </div>
     </div>
      <div class='preview-four' v-if='item.floorName === "quadrangle1-content"'>
        <div class='preview-title'>
          <span>{{ item.floorTitle }}</span>
          <div class='preview-title-arrow' v-if='item.isMore === "0"'>
            <span>更多</span>
            <img src='@/assets/img/arrow-right.png'>
          </div>
        </div>
        <div class='gild'>
          <template v-for='(list,ind) in item.dataList'>
            <img :src='list.imageUrl' v-if='ind<4' :key='ind'>
          </template>
        </div>
      </div>
      <div class='preview-three' v-if='item.floorName === "three-item-content"'>
        <div class='preview-title'>
          <span>{{ item.floorTitle }}</span>
          <div class='preview-title-arrow' v-if='item.isMore === "0"'>
            <span>更多</span>
            <img src='@/assets/img/arrow-right.png'>
          </div>
        </div>
        <div class='gild'>
          <template v-for='(list,ind) in item.dataList'>
            <img :src='list.imageUrl' v-if='ind<3' :key='ind'>
          </template>
        </div>
      </div>
      <div class='preview-binary' v-if='item.floorName === "right-two-content"'>
        <div class='preview-title'>
          <span>{{ item.floorTitle }}</span>
          <div class='preview-title-arrow' v-if='item.isMore === "0"'>
            <span>更多</span>
            <img src='@/assets/img/arrow-right.png'>
          </div>
        </div>
        <div class='preview-tow'>
          <div class='preview-tow-item'>
            <dl>
              <dt>{{ item.dataList[0].title }}</dt>
              <dd>{{ item.dataList[0].subTitle1 }}</dd>
            </dl>
            <img :src='item.dataList[0].imageUrl'>
          </div>
          <template v-if='item.dataList[1]'>
            <div class='solid'></div>
            <div class='preview-tow-item'>
              <dl>
                <dt>{{ item.dataList[1].title }}</dt>
                <dd>{{ item.dataList[1].subTitle1 }}</dd>
              </dl>
              <img :src='item.dataList[1].imageUrl'>
            </div>
          </template>
        </div>
      </div>
      <div class='preview-half' v-if='item.floorName === "one-half-content"'>
        <div class='preview-title'>
          <span>{{ item.floorTitle }}</span>
          <div class='preview-title-arrow' v-if='item.isMore === "0"'>
            <span>更多</span>
            <img src='@/assets/img/arrow-right.png'>
          </div>
        </div>
        <div class='preview-half-img'>
          <img :src='list.imageUrl' v-for='(list,ind) in item.dataList' :key='ind'>
        </div>
      </div>
      <div class='preview-banner-img' v-if="item.floorName === 'banner3-content'">
        <img :src='item.dataList[0].imageUrl'>
      </div>
      <div class='preview-sliding' v-if='item.floorName === "discover_goods_list"'>
        <div class='preview-title'>
          <span>{{ item.floorTitle }}</span>
          <div class='preview-title-arrow' v-if='item.isMore === "0"'>
            <span>更多</span>
            <img src='@/assets/img/arrow-right.png'>
          </div>
        </div>
        <div class='preview-sliding-item'>
          <div v-for='(list,ind) in item.dataList' :key='ind'>
            <img :src='list.imageUrl'>
            <span>{{ list.title }}</span>
            <span>{{ list.subTitle1 }}</span>
            <span v-if='list.subTitle2'>¥{{ list.subTitle2 }}</span>
            <del v-if='list.subTitle3'>¥{{ list.subTitle3 }}</del>
          </div>
        </div>
      </div>
      <div class='preview-lateral-two' v-if='item.floorName === "two-half-content"'>
        <div class='preview-title'>
          <span>{{ item.floorTitle }}</span>
          <div class='preview-title-arrow' v-if='item.isMore === "0"'>
            <span>更多</span>
            <img src='@/assets/img/arrow-right.png'>
          </div>
        </div>
        <div class='preview-sliding-item'>
          <div v-for='(list,ind) in item.dataList' :key='ind'>
            <img :src='list.imageUrl'>
            <span>{{ list.title }}</span>
            <span>{{ list.subTitle1 }}</span>
          </div>
        </div>
      </div>
      <div class='preview-six' v-if='item.floorName === "six-hexagram-content"'>
        <div class='preview-title'>
          <span>{{ item.floorTitle }}</span>
          <div class='preview-title-arrow' v-if='item.isMore === "0"'>
            <span>更多</span>
            <img src='@/assets/img/arrow-right.png'>
          </div>
        </div>
        <div class='gild'>
          <template v-for='(list,ind) in item.dataList'>
            <img v-if='ind<6' :src='list.imageUrl' :key='ind'>
          </template>
        </div>
      </div>
      <div class='preview-three-sliding' v-if='item.floorName === "commom-three-waterfall-content"'>
        <div class='preview-title'>
          <span>{{ item.floorTitle }}</span>
          <div class='preview-title-arrow' v-if='item.isMore === "0"'>
            <span>更多</span>
            <img src='@/assets/img/arrow-right.png'>
          </div>
        </div>
        <div class='preview-sliding-item'>
          <div v-for='(list,ind) in item.dataList' :key='ind'>
            <img :src='list.imageUrl'>
            <span>{{ list.title }}</span>
            <span>{{ list.subTitle1 }}</span>
            <span v-if='list.subTitle2'>¥{{ list.subTitle2 }}</span>
            <del v-if='list.subTitle3'>¥{{ list.subTitle3 }}</del>
          </div>
        </div>
      </div>
    </div>
    <div class='empt' v-if='floorList.length === 0'>暂无数据</div>
    <div class='preview-recommends'>
      <div class='preview-recommend-item'>
        <div class='preview-recommend-tit'>
          <span style='color: #E91639;font-weight:500'>{{ commendList.floorTitle }}</span>
          <span :style='{background: commendList.subtitleFirst ? "#e91639" : ""}' style='padding:0.01rem 0.05rem;border-radius: 0.1rem;color: #FFFFFF;'>{{ commendList.subtitleFirst }}</span>
        </div>
        <template v-for='(item,index) in floorList'>
          <template v-if='item.isNavigation === "1"'>
            <div style='display: none' :key='index'></div>
            <div v-for='(data,inds) in item.dataList' :key='inds' style='display: flex;align-items: center'>
              <div class='solid'></div>
              <div class='preview-recommend-tit' >
                <span>{{ data.title }}</span>
                <span>{{ data.subTitle1 }}</span>
              </div>
            </div>
          </template>
        </template>

      </div>
    </div>
    <div class='preview-recommend'>
      <div v-for='(item,index) in commendList.contentList' :key='index'>
        <div class='preview-recommend-cont' v-if='item.type === 2'>
          <div class='img'>
            <img :src='item.storeThumbnail'>
          </div>
          <div class='preview-recommend-cont-r'>
            <span class='tit' style='white-space: nowrap;text-overflow: ellipsis;'>{{ item.storeName }}</span>
            <div style='margin: 0.06rem 0'>
              <span><van-rate v-model="item.score" allow-half readonly size='13'/><span class='num'>{{ item.score }}</span></span>
              <span class='num' style='color:#999999'>¥{{ item.perCapitaSpend }}/人</span>
            </div>
            <span class='cont'>{{ item.merTypeName }}</span>
            <div style='display: flex;margin: 0.06rem 0'>
              <img class='location' src='@/assets/img/location.png' alt=''>
              <div class='cont'>{{ item.address }}</div>
            </div>
            <span class='bor' v-if='item.discount'>{{ item.discount }}</span>
          </div>
        </div>
        <div class='preview-recommend-cont' v-if='item.type === 1||item.type === 0'>
          <div class='img'>
            <img :src='item.contentFilepath ? item.contentFilepath : item.filepath'>
          </div>
          <div class='preview-recommend-cont-r'>
            <span class='tit' style='-webkit-line-clamp: 2;text-overflow: ellipsis;display: -webkit-box;-webkit-box-orient: vertical;'>{{ item.couponName }}</span>
            <span class='cont' style='margin: 0.12rem 0 0.23rem'>{{ item.storeName }}</span>
            <div class='price'>
              <span>¥ {{ item.couponMoney }}</span>
              <del>¥{{ item.couponFaceValue }}</del>
              <div v-if='item.discount'>{{ item.discount }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <van-popup
      v-model="showArea"
      round
      position="bottom"
      class="area-pop"
    >
      <div class="pop-top">
        <div class="van-picker__toolbar">
          <button type="button" class="van-picker__cancel" @click="clickClose">取消</button>
          <div class="van-ellipsis van-picker__title">请选择所在地区</div>
          <button type="button" class="van-picker__confirm" @click="query">确认</button>
        </div>
      </div>
      <div class="pop-body-container">
        <van-picker
          :columns="iosCity"
          value-key="cityName"
          @change="onChanges"
        />
      </div>
    </van-popup>
  </div>
</template>

<script>
  import { lifeFloor, getRecommendList } from '../../api/floor'
  import axios from 'axios'
  import qs from 'qs'
  import { Dialog } from 'vant'

  export default {
    name: 'Preview',
    data() {
      return {
        showArea: false,
        value: 3.5,
        floorList: [],
        commendList: [],
        pageNum: 1,
        pageSize: 10,
        iosCity: [],
        cityCode: '',
        cityName: ''
      }
    },
    created() {
      const _url = '/sysadmin/a/group/lifeAppPage/floorConfig/getAvailableCityInfo.do'
      axios({
        url: _url,
        method: 'get',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        }
      }).then(res => {
        this.iosCity = res.data.resultObj
        this.cityCode = res.data.resultObj[0].cityCode
        this.cityName = res.data.resultObj[0].cityName
        this.lifeFloor()
        this.getRecommendList()
      })
    },
    methods: {
      cityChang() {
        if (this.iosCity.length === 1) return
        this.showArea = true
      },
      lifeFloor() {
        this.floorList = []
        lifeFloor({
          cityCode: this.cityCode,
          pageNum: 1,
          pageSize: 10
        }).then(res => {
          if (res.code === 200) {
            this.floorList = res.data.floorInfo
          }
        })
      },
      getRecommendList() {
        getRecommendList({
          cityCode: this.cityCode,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          latitude: '',
          longitude: ''
        }).then(res => {
          res.data.contentList.forEach(item => {
            item.score = Number(item.score)
          })
          this.commendList = res.data
        })
      },
      onChanges(picker, value, index) {
        this.cityCode = value.cityCode
        this.cityName = value.cityName
      },
      query() {
        this.lifeFloor()
        this.getRecommendList()
        this.showArea = false
      },
      clickClose() {
        this.showArea = false
      }
    }
  }
</script>

<style scoped lang='scss'>
  .preview-box{
    background: #fbfbfb;
    height: 100vh;
    overflow: hidden;
    overflow-y: auto;
    width: 100%;
    img{
      border-radius: 0.04rem;
    }
  }
  .preview-header{
    margin: 0.1rem 0.15rem 0.2rem;
    display: flex;
    align-items: center;
    border-radius: 0.04rem;
    .tit{
      width: 0.5rem;
      font-size: 0.15rem;
      font-weight: 400;
      color: #333333;
      line-height: 0.21rem;
    }
    img{
      width: 0.13rem;
      height: 0.07rem;
      margin: 0 0.15rem 0 0.06rem;
    }
    .van-search{
      width: 2.66rem;
      height: 0.29rem;
      background: #ededed;
      padding: 0;
      border-radius: 0.14rem;
      .van-cell{padding: 0;}
      .van-search__content{
        background: #ededed;
        border-radius: 0.14rem;
      }
    }
  }
  .preview-banner{
    height: 1.38rem;
    margin-bottom: 0.2rem;
    position: relative;
    border-radius: 0.04rem;
    &>li{
      width: 3.25rem;
      height: 100%;
      box-shadow: 0rem 0.01rem 0.02rem 0rem rgba(192,192,192,0.08);
      img{
        width: 100%;
        height: 100%;
      }
    }
    li:nth-child(1){
      height: 1.02rem;
      position: absolute;
      top: 0.18rem;
      right: 3.6rem;
    }
    li:nth-child(2){
      position: absolute;
      top: 0;
      left: 0.25rem;
    }
    li:nth-child(3){
      height: 1.02rem;
      position: absolute;
      top: 0.18rem;
      left: 3.6rem;
    }
  }
  .preview-ten{
    display: flex;
    flex-wrap: wrap;
    margin:0  0.15rem 0.05rem;
    border-radius: 0.04rem;
    .preview-ten-item{
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin: 0 0.06rem 0.15rem 0;
      img{
        width: 0.31rem;
        height: 0.31rem;
      }
      span{
        width: 0.6rem;
        height: 0.17rem;
        font-size: 0.12rem;
        font-weight: 400;
        color: #333333;
        line-height: 0.17rem;
        margin-top: 0.05rem;
        overflow: hidden;
      }
    }
    .preview-ten-item:nth-child(5n){
      margin-right: 0;
    }
  }
  .preview-tow{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0.18rem 0.25rem 0.34rem;
    border-radius: 0.04rem;
    .solid{
      width: 0.01rem;
      height: 0.61rem;
      background: #efefef;
      margin:0 0.15rem;
    }
    .preview-tow-item{
      display: flex;
      justify-content: space-between;
      width: 50%;
      &>dl{
        margin-left: 0.1rem;
        width: 0.8rem;
        overflow: hidden;
        dt,dd{overflow: hidden;}
      }
      img{
        width: 0.55rem;
        height: 0.55rem;
        border-radius: 50%;
      }
      &>dl>dt{
        height: 0.21rem;
        font-size: 0.15rem;
        font-weight: 400;
        color: #333333;
        line-height: 0.21rem;
        text-align: left;
        margin: 0.05rem 0;
      }
      &>dl>dd{
        height: 0.19rem;
        font-size: 0.12rem;
        font-weight: 400;
        color: #999999;
        line-height: 0.19rem;
        text-align: left;
      }
    }
  }
  .preview-bg-box{
    padding-top: 1.28rem;
    margin: 0 0.1rem 0.12rem;
    display: flex;
    justify-content: space-around;
    border-radius: 0.04rem;
    .preview-bg-box-item{
      margin-bottom: 0.12rem;
      width: 31%;
      img{
        width: 1.05rem;
        height: 0.69rem;
      }
      &>dl>dt{
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        height: 0.14rem;
        font-size: 0.14rem;
        font-weight: 500;
        text-align: center;
        color: #000000;
        line-height: 0.14rem;
        text-shadow: 0rem 0.01rem 0.01rem 0.01rem rgba(153,153,153,0.04);
        margin: 0.08rem 0 0.07rem;
      }
      &>dl>dd{
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        height: 0.13rem;
        font-size: 0.13rem;
        font-weight: 400;
        text-align: center;
        color: #666666;
        line-height: 0.13rem;
        text-shadow: 0rem 0.01rem 0.01rem 0.01rem rgba(153,153,153,0.04);
      }
    }
  }
  .preview-title{
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 0.27rem;
    border-radius: 0.04rem;
    margin-bottom: 0.12rem;
    &>span{
      width: 85%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      text-align: left;
      height: 0.27rem;
      font-size: 0.19rem;
      font-weight: bold;
      color: #333330;
      line-height: 0.27rem;
    }
    .preview-title-arrow{
      &>span{
        height: 0.13rem;
        font-size: 0.13rem;
        font-weight: 400;
        color: #999999;
        line-height: 0.13rem;
        margin-right: 0.06rem;
      }
      img{
        width: 0.06rem;
        height: 0.1rem;
      }
    }
  }
  .preview-two-three{
    margin: 0 0.1rem 0.16rem;
    padding: 0.12rem;
    .gild{
      display: grid;
      grid-auto-flow: row;
      grid-template-columns: 1.05rem 1.05rem 1.05rem;
      grid-template-rows: 1.05rem 1.05rem;
      grid-column-gap: 0.08rem;
      grid-row-gap: 0.08rem;
      img{
        width: 100%;
        height: 100%;
      }
      img:first-child{
        grid-column-start: 1;
        grid-column-end: 3;
      }
    }
  }
  .preview-one-three{
    margin: 0 0.1rem 0.16rem;
    padding: 0.12rem;
    .gild{
      display: grid;
      grid-auto-flow: row;
      grid-template-columns: 0.82rem 0.82rem 0.82rem;
      grid-template-rows: 0.98rem 0.82rem;
      grid-column-gap: 0.42rem;
      grid-row-gap: 0.12rem;
      img{
        width: 100%;
        height: 100%;
      }
      img:first-child{
        grid-column-start: 1;
        grid-column-end: 4;
      }
    }
  }
  .preview-four{
    margin: 0 0.1rem 0.16rem;
    padding: 0.12rem;
    .gild {
      display: grid;
      grid-auto-flow: row;
      grid-template-columns: 1.62rem 1.62rem;
      grid-template-rows: 0.84rem 0.84rem;
      grid-column-gap: 0.08rem;
      grid-row-gap: 0.08rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .preview-three{
    margin: 0 0.1rem 0.16rem;
    padding: 0.12rem;
    .gild {
      display: grid;
      grid-auto-flow: row;
      grid-template-columns: 1.05rem 1.05rem 1.05rem;
      grid-template-rows: 1.1rem;
      grid-column-gap: 0.08rem;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .preview-binary{
    margin: 0 0.1rem 0.16rem;
    padding: 0.12rem;
    .preview-tow{
      margin: 0;
      img{
        width: 0.55rem;
        height: 0.55rem;
        border-radius: 0.04rem;
      }
      .solid{
        margin: 0 0.25rem;
      }
      dl{
        margin-left: 0;
      }
    }
  }
  .preview-half{
    margin: 0 0.1rem 0.16rem;
    padding: 0.12rem 0 0.12rem 0.12rem;
    .preview-title{padding-right: 0.12rem;}
    .preview-half-img{
      height: 1.2rem;
      width: 100%;
      overflow: hidden;
      //overflow-x: auto;
      white-space: nowrap;
      img{
        width: 2.55rem;
        height: 1.2rem;
        margin-right: 0.1rem;
      }
    }
    .preview-half-box{
      width: 100%;
      height: 1.2rem;
      overflow: hidden;
      //overflow-x: auto;
      white-space: nowrap;
      .preview-half-box-item{
        display: inline-flex;
        margin-right: 0.1rem;
        width: 2.4rem;
        height: 0.84rem;
        border-radius: 0.04rem;
        box-shadow: 0rem 0.01rem 0.02rem 0.01rem rgba(0,0,0,0.10);
        padding: 0.2rem 0 0.15rem 0.15rem;
        .preview-half-box-item-img{
          margin-right: 0.1rem;
          width: 0.8rem;
          height: 0.8rem;
          border-radius: 50%;
        }
        .preview-half-box-item-l{
          display: flex;
          flex-direction: column;
          span{
            width: 0.42rem;
            height: 0.2rem;
            font-size: 0.14rem;
            font-weight: 500;
            color: #333333;
            line-height: 0.2rem;
          }
          span:nth-child(2){
            width: 0.65rem;
            height: 0.19rem;
            font-size: 0.13rem;
            font-weight: 400;
            color: #999999;
            text-align: left;
            line-height: 0.19rem;
            margin: 0.05rem 0 0.07rem;
          }
          .preview-half-box-item-l-img{
            display: flex;
            img{
              width: 0.34rem;
              height: 0.34rem;
              margin-right: 0.05rem;
              border-radius: 50%;
            }
          }
        }
      }
    }
  }
  .preview-banner-img{
    width: 3.55rem;
    height: 1rem;
    margin: 0 0.1rem 0.16rem;
    box-shadow: 0rem 0.01rem 0.02rem 0rem rgba(192,192,192,0.08);
    img{
      width: 100%;
      height: 100%;
    }
  }
  .preview-sliding{
    margin: 0 0.1rem 0.16rem;
    padding: 0.12rem 0 0.12rem 0.12rem;
    .preview-title{padding-right: 0.12rem;}
  }
  .preview-sliding-item{
    width: 100%;
    height: 2.01rem;
    overflow: hidden;
    //overflow-x: auto;
    white-space: nowrap;
    display: flex;
    div{
      width: 1.03rem;
      //height: 2.01rem;
      margin-right: 0.08rem;
      display: flex;
      flex-direction: column;
      text-align: left;
      img{
        width: 1.03rem;
        height: 1.03rem;
      }
      span:nth-child(2){
        width: 100%;
        height: 0.2rem;
        font-size: 0.14rem;
        font-weight: 500;
        color: #333333;
        line-height: 0.2rem;
        overflow: hidden;
        text-overflow: ellipsis;
        margin: 0.05rem 0;
      }
      span:nth-child(3){
        height: 0.19rem;
        font-size: 0.13rem;
        font-weight: 400;
        color: #999999;
        line-height: 0.19rem;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      span:nth-child(4){
        width: 0.6rem;
        height: 0.19rem;
        font-size: 0.13rem;
        font-weight: 400;
        color: #e91639;
        line-height: 0.19rem;
        margin: 0.05rem 0;
      }
      del{
        width: 0.32rem;
        height: 0.19rem;
        font-size: 0.13rem;
        font-weight: 400;
        text-decoration:  line-through;
        color: #999999;
      }
    }
  }
  .preview-three-sliding{
    margin: 0 0.1rem 0.16rem;
    padding: 0.12rem;
    .preview-sliding-item{
      display: flex;
      flex-wrap: wrap;
      height: auto;
      overflow: auto;
      div{
        width: .95rem;
        img{
          width: .95rem;
          height: .95rem;
        }
      }
      div:nth-child(3n){
        margin-right: 0;
      }
    }
  }
  .preview-lateral-two{
    margin: 0 0.1rem 0.16rem;
    padding: 0.12rem 0 0.12rem 0.12rem;
    .preview-title{padding-right: 0.12rem;}
    .preview-sliding-item{
      height: 1.64rem;
      div{
        width: 1.42rem;
        height: 1.64rem;
        margin-right: 0.04rem;
        img{
          width: 1.42rem;
          height: 0.8rem;
        }
      }
    }
  }
  .preview-six{
    margin: 0 0.1rem 0.16rem;
    padding: 0.12rem;
    .gild {
      display: grid;
      grid-auto-flow: row;
      grid-template-columns: 1.62rem 1.62rem;
      //grid-template-rows: 0.89rem 0.89rem 0.89rem;
      grid-column-gap: 0.08rem;
      grid-row-gap: 0.08rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .preview-recommends{
    position: sticky;
    top: 0;
    background: white;
    height: .5rem;
    z-index: 666;
    padding: 0.12rem;
    .preview-recommend-item{
      display: flex;
      align-items: center;
      height: 0.47rem;
      margin-bottom: 0.2rem;
      overflow: hidden;
      .preview-recommend-tit{
        display: flex;
        flex-direction: column;
        align-items: center;
        span:nth-child(1){
          //width: 0.64rem;
          height: 0.23rem;
          font-size: 0.16rem;
          font-weight: 400;
          color: #333333;
          line-height: 0.23rem;
          overflow: hidden;
        }
        span:nth-child(2){
          width: 0.62rem;
          height: 0.17rem;
          font-size: 0.12rem;
          font-weight: 400;
          color: #333333;
          line-height: 0.17rem;
          margin-top: 0.05rem;
        }
      }
      .solid{
        width: 0.01rem;
        height: 0.28rem;
        background: #d8d8d8;
        margin: 0 0.12rem;
      }
      .solid:first-child{
        width: 1px;
      }
    }
  }
  .preview-recommend{
    margin: 0 0.1rem 0.16rem;
    padding: 0.12rem;
    .preview-recommend-cont{
      display: flex;
      padding: 0.12rem 0;
      border-radius: 0.04rem;
      box-shadow: 0rem 0.01rem 0.01rem 0.01rem rgba(153,153,153,0.04);
      .img{
        width: 1.05rem;
        height: 1.05rem;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .preview-recommend-cont-r{
        width: 2rem;
        text-align: left;
        margin-left: 0.12rem;
        .tit{
          font-size: 0.15rem;
          font-weight: 600;
          color: #333333;
          line-height: 0.21rem;
          overflow: hidden;
        }
        .num{
          height: 0.19rem;
          font-size: 0.13rem;
          font-weight: 400;
          color: #e91639;
          line-height: 0.19rem;
          margin: 0.07rem 0 0 0.05rem;
        }
        .cont{
          display: block;
          width: 2.06rem;
          height: 0.19rem;
          font-size: 0.13rem;
          font-weight: 400;
          text-align: left;
          color: #999999;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .location{
          width: 0.08rem;
          height: 0.1rem;
          margin-right: 0.05rem;
        }
        .bor{
          height: 0.17rem;
          font-size: 0.12rem;
          font-weight: 400;
          color: #ffb301;
          text-align: center;
          line-height: 0.17rem;
          border: 0.01rem solid #ffb301;
          border-radius: 0.02rem;
          padding: 0.01rem 0.04rem;
        }
      }
      .price{
        display: flex;
        align-items: center;
        span{
          height: 0.25rem;
          font-size: 0.18rem;
          font-weight: 500;
          color: #e91639;
          line-height: 0.25rem;
        }
        del{
          height: 0.2rem;
          font-size: 0.14rem;
          font-weight: 400;
          color: #999999;
          line-height: 0.2rem;
          margin:0 0.05rem 0 0.14rem;
        }
        div{
          background: url("../../assets/img/youhui.png") no-repeat;
          padding: 0.01rem 0.04rem 0.01rem 0.12rem;
          background-size: 100% 100%;
        }
      }
    }
  }
  .empt{
    width: 100%;
    height: 300px;
    line-height: 300px;
  }
  .area-pop.van-popup {
    overflow: hidden;
    border-radius: 6px 6px 0px 0px;
  }

  .pop-top {
    .pop-title {
      height: 0.42rem;
      line-height: 0.42rem;
      background-color: #fafafa;
      text-align: left;
      position: relative;
      padding: 0 0.18rem;
      font-size: 0.15rem;

      .close-icon {
        width: 0.15rem;
        height: 0.15rem;
        position: absolute;
        right: 0.18rem;
        top: 50%;
        transform: translate(0, -50%);
      }
    }

    .pop-head {
      height: .58rem;
      line-height: .58rem;
      padding: 0 0.13rem;
      text-align: left;

      span {
        margin-right: 0.28rem;
        font-size: 0.13rem;
        color: #333333;
      }
    }
  }

  .pop-body-container {
    padding: 0 0.18rem 0.1rem;
    display: flex;
    text-align: left;

    div {
      width: 100%;
      overflow-y: scroll;
    }
  }
</style>
